import { useParams } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useContent } from "../app/ContentContext";

export default function TreatmentDetail() {
  const { slug } = useParams();
  const { treatments, treatmentLinkInfo } = useContent();

  const treatment = treatments.find((t) => t.slug === slug);

  if (!treatment) {
    return (
      <Typography variant="h6" sx={{ p: 4 }}>
        Treatment not found
      </Typography>
    );
  }

  return (
    <Box sx={{ p: 4, maxWidth: "700px", margin: "auto" }}>
      <Typography
        variant="h4"
        color="secondary.main"
        textAlign="center"
        gutterBottom
      >
        {treatment.title}
      </Typography>

      <Box
        component="img"
        src={treatment.image}
        alt={treatment.title}
        sx={{
          display: "block",
          width: { xs: "80%", sm: "60%", md: "60%" },
          height: "auto",
          borderRadius: 3,
          boxShadow: "0 2px 16px rgba(7, 73, 116, 0.12)",
          mx: "auto",
          mb: 4,
        }}
      />
      {treatment.list &&
        treatment.list.map((service, index) => (
          <Box
            component="li"
            key={index}
            sx={{
              fontSize: {
                xs: "1rem",
                sm: "1.4rem",
              },
              color: "text.secondary",
              lineHeight: 1.5,
            }}
          >
            {service}
          </Box>
        ))}
      {[1, 2, 3, 4, 5].map((num) => (
        <Box key={num} sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            {treatment[`heading${num}` as keyof typeof treatment]}
          </Typography>
          {num === 2 && treatment.listInfo && (
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              {treatment.listInfo.map((info, index) => (
                <Typography
                  component="li"
                  key={index}
                  sx={{
                    fontSize: "inherit",
                    lineHeight: 1.6,
                    color: "text.secondary",
                  }}
                >
                  {info}
                </Typography>
              ))}
            </Box>
          )}
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.8, color: "text.secondary" }}
          >
            {treatment[`section${num}` as keyof typeof treatment]}
          </Typography>
        </Box>
      ))}
      {treatment.listSleep && (
        <Box component="ul" sx={{ pl: 3, mt: 2 }}>
          {treatment.listSleep.map((item, index) => (
            <Typography
              component="li"
              key={index}
              sx={{ lineHeight: 1.6, color: "text.secondary" }}
            >
              {item}
            </Typography>
          ))}
        </Box>
      )}
      {treatment.linkSleep && (
        <Button
          href={treatment.linkSleep}
          target="_blank"
          rel="noopener noreferrer"
          // Intentionally NOT theme.palette.primary.main — predates ThemeProvider,
          // so it rendered as MUI's old default blue. Kept literal to preserve that
          // look. TODO: confirm with product whether this should become brand teal.
          sx={{ color: "#1976d2", textDecoration: "underline" }}
        >
          {treatmentLinkInfo}
        </Button>
      )}
    </Box>
  );
}
